import React, { useState, useEffect } from 'react';
import Dashboard from './components/Dashboard';
import SessionExpiredModal from './components/SessionExpiredModal';
import './App.css';
import useAuth from './hooks/useAuth';
import { useWindowManager } from './hooks/useWindowManager';
import { SearchProvider } from './context/SearchContext';
import { ThemeProvider } from './context/ThemeContext';

const App = () => {
  const [showSessionExpiredModal, setShowSessionExpiredModal] = useState(false);
  const { setAuth } = useAuth();
  const { logout: windowManagerLogout } = useWindowManager();

  useEffect(() => {
    const handleSessionExpired = () => {
      setShowSessionExpiredModal(true);
    };

    window.addEventListener('sessionExpired', handleSessionExpired);

    return () => {
      window.removeEventListener('sessionExpired', handleSessionExpired);
    };
  }, []);

  const handleLogout = () => {
    windowManagerLogout();
    setAuth({});
    setShowSessionExpiredModal(false);
    window.location.href = '/';
  };

  return (
    <ThemeProvider>
    <SearchProvider>
    <div className="w-full bg-dashboard dark:bg-dark-dashboard dark:text-white">
      <Dashboard />
      <SessionExpiredModal
        isOpen={showSessionExpiredModal}
        onConfirm={handleLogout}
      />
    </div>
    </SearchProvider>
    </ThemeProvider>
  );
};

export default App;